/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeAdminSettings.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Admin Settings Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Wednesday, January 31, 2019 - 12:08 AM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      01/31/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const ADMINSETTING_LIST_CONTAINER_LOADED = 'ADMINSETTING_LIST_CONTAINER_LOADED';
export const ADMINSETTING_LIST_CONTAINER_UNLOADED = 'ADMINSETTING_LIST_CONTAINER_UNLOADED';
export const ADMINSETTING_LIST_TABLE_LOADED = 'ADMINSETTING_LIST_TABLE_LOADED';
export const ADMINSETTING_LIST_TABLE_UNLOADED = 'ADMINSETTING_LIST_TABLE_UNLOADED';

export const ADMINSETTING_LIST_CHANGE_GROUP = 'ADMINSETTING_LIST_CHANGE_GROUP';
export const ADMINSETTING_SELECT_ROW = 'ADMINSETTING_SELECT_ROW';

export const ADMINSETTING_ADD = 'ADMINSETTING_ADD';
export const ADMINSETTING_EDIT = 'ADMINSETTING_EDIT';
export const ADMINSETTING_DELETE = 'ADMINSETTING_DELETE';
export const ADMINSETTING_OPEN_WARNING = 'ADMINSETTING_OPEN_WARNING';
export const ADMINSETTING_CLOSE_WARNING = 'ADMINSETTING_CLOSE_WARNING';

export const ADMINSETTING_EDIT_CONTAINER_LOADED = 'ADMINSETTING_EDIT_CONTAINER_LOADED';
export const ADMINSETTING_EDIT_CONTAINER_UNLOADED = 'ADMINSETTING_EDIT_CONTAINER_UNLOADED';
export const ADMINSETTING_EDIT_COMPANIES_LOADED = 'ADMINSETTING_EDIT_COMPANIES_LOADED';
export const ADMINSETTING_EDIT_USERS_LOADED = 'ADMINSETTING_EDIT_USERS_LOADED';
export const ADMINSETTING_EDIT_BLOCKGROUP_LOADED = 'ADMINSETTING_EDIT_BLOCKGROUP_LOADED';
export const ADMINSETTING_EDIT_BLOCKTREE_LOADED = 'ADMINSETTING_EDIT_BLOCKTREE_LOADED';
export const ADMINSETTING_EDIT_DRAW_COMPANYOPTIONS = 'ADMINSETTING_EDIT_DRAW_COMPANYOPTIONS';
export const ADMINSETTING_EDIT_DRAW_USEROPTIONS = 'ADMINSETTING_EDIT_DRAW_USEROPTIONS';
export const ADMINSETTING_EDIT_DRAW_BLOCKTREE = 'ADMINSETTING_EDIT_DRAW_BLOCKTREE';
export const ADMINSETTING_EDIT_BLOCKFORMAT_LOADED = 'ADMINSETTING_EDIT_BLOCKFORMAT_LOADED';

export const ADMINSETTING_UPDATE_VALUE = 'ADMINSETTING_UPDATE_VALUE';

export const ADMINSETTING_EDIT_FORM_LOADED = 'ADMINSETTING_EDIT_FORM_LOADED';
export const ADMINSETTING_EDIT_FORM_UNLOADED = 'ADMINSETTING_EDIT_FORM_UNLOADED';

export const ADMINSETTING_SET_GROUP_SELECT = 'ADMINSETTING_SET_GROUP_SELECT';
export const ADMINSETTING_EDIT_DATA_LOAD = 'ADMINSETTING_EDIT_DATA_LOAD';

export const ADMINSETTING_EDIT_CONTAINER_SUBMIT = 'ADMINSETTING_EDIT_CONTAINER_SUBMIT';
export const ADMINSETTING_EDIT_CONTAINER_CANCEL = 'ADMINSETTING_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeAdminSettings.js